module.exports = __webpack_public_path__ + "img/p3_1.9fbc3a21.png";